import axios from 'axios';
import systemAPI from '@/services/API/system'


const state = {
    list : [],
    loading : true,
    outDated : true,
    randomContact : null,
    page : 1,
    pages : 0, //nombre de page total
    per_page : 20,
    count : 0,
    search : '',
    orderBy:{orderName : 'last_name',  direction:'ASC'},
    sort_icon : 'el-icon-caret-bottom',
    icons : {
      'DESC' : 'el-icon-caret-bottom',
      'ASC' : 'el-icon-caret-top'
    },
    listTags : [],
    filters : {
      associated_contact : false,
      non_associated_contact : false,
      customerTypes : [{id:0, code:'Client particulier'},{id:1, code:'Client corporatif'}],
      checkedCustomerTypes : [],
      checkedCustomerClasses : [],
      checkedTags : []
    }
}

const getters= {
  contactListTags(state){
    return state.listTags;
  },
  contactSortIcons(state){
    return state.icons;
  },
  contactSortIcon(state){
    return state.sort_icon;
  },
  contactOrderBy(state){
    return state.orderBy;
  },
  contactSearch(state, getters){
    return state.search;
  },
  checkedAssociatedContact(state, getters){
    return state.filters.associated_contact;
  },
  checkedNonAssociatedContact(state, getters){
    return state.filters.non_associated_contact;
  },
  checkedContactCustomerTypes(state, getters){
    return state.filters.checkedCustomerTypes;
  },
  isContactLoading(state, getters){
    return state.loading;
  },
  contacts(state, getters){
    return state.list;
  },
  contacts_pages(state, getters){
    return state.pages;
  },
  contacts_page(state, getters){
    return state.page;
  },
  contacts_per_page(state, getters){
    return state.per_page;
  },
  contacts_length(state,getters){
    return state.count;
  },
  checkedContactCustomerClasses(state, getters){
    return state.filters.checkedCustomerClasses;
  },
  checkedContactTags(state){
    return state.filters.checkedTags;
  }

}

const mutations = {
  SET_LIST_TAGS(state, listTags){
    state.listTags = listTags;
  },
  SET_SORT_ICON(state, icon){
    state.sort_icon =icon;
  },
  SET_ORDERNAME_AND_DIRECTION(state, {orderName, direction}){
    state.orderBy.orderName = orderName;
    state.orderBy.direction = direction;
  },
  RESET_FILTERS(state){
    state.filters.associated_contact = false,
    state.filters.non_associated_contact = false,
    state.filters.checkedCustomerTypes =[];
    state.filters.checkedCustomerClasses= [];
    state.filters.checkedTags = [];

  },
  changeContactCustomerTypeFilter(state, customerTypes){
    state.filters.checkedCustomerTypes = customerTypes;
  },
  changeContactCustomerClassFilter(state, customerClasses){
    state.filters.checkedCustomerClasses = customerClasses;
  },
  update_total_pages(state,newTotal){
    state.pages = newTotal;
    if(state.pages<state.page){
      state.page = state.pages;
    }
  },
  update_contacts_list(state, contactResponse){
    // console.log("UPDATE CONTACTS LIST : ", contactResponse);
    state.list = contactResponse.contacts;
    state.outDated = false;
    state.pages = contactResponse.pages;

    // state.page = contactResponse.page<state.page?contactResponse.page:state.page;
    state.page = contactResponse.page;
    // console.log("Page : ", state.page);
    state.count = contactResponse.count;
  },
  changeContactAssociatedFilter(state, associated_contact){
    state.filters.associated_contact = associated_contact;
  },
  changeContactNonAssociatedFilter(state, non_associated_contact){
    state.filters.non_associated_contact = non_associated_contact;
  },
  changeLoadingState(state, loading){
    // console.log("CHANGE LOADING STATE");
    state.loading = loading;
  },
  setRandomContact(state, contact){
    state.randomContact = contact;
  },
  invalidateList(state){
    state.outDated = true;
  },
  updateContactSearch(state,searchTerms){
    state.search = searchTerms;
  },
  changeContactTag(state, checkedTags){
    state.filters.checkedTags=checkedTags
  }
};
const actions = {
    ['CONTACT_FETCH_TAGS'] : ({commit, state}, active)=>{
      systemAPI.getTags('CONTACT', active)
        .then(listTags=>{
          commit('SET_LIST_TAGS',listTags);
        })

    },
    ['CONTACT_CHANGE_SORT_ICON'] : ({commit}, icon)=>{
      commit('SET_SORT_ICON',icon);
    },
    ['CONTACT_CHANGE_ORDER_BY'] : ({commit, dispatch},{orderName, direction})=>{
      commit('SET_ORDERNAME_AND_DIRECTION', {orderName, direction});
      dispatch('CONTACTS_INVALIDATE_LIST');
      dispatch('CONTACTS_LOAD_CONTACTS');
    },
    ['CONTACT_RESET_FILTERS'] : ({commit, dispatch})=>{
      commit('RESET_FILTERS');
      dispatch('CONTACTS_INVALIDATE_LIST');
      dispatch('CONTACTS_LOAD_CONTACTS')
    },
    ['CONTACTS_LOAD_CONTACTS'] : ({commit, dispatch},page)=>{
      // console.log("LOAD CUSTOMERS Page : ", page);
      var params = {};
      params.customerTypes = [];
      // params['primary-only']=true
      params.associated_contact = state.filters.associated_contact?state.filters.associated_contact:undefined;
      params.non_associated_contact = state.filters.non_associated_contact?state.filters.non_associated_contact:undefined;

      params.tags = [];
      _.forEach(state.filters.checkedTags, t=>{
       params.tags.push(t);
      })

      _.forEach(state.filters.checkedCustomerTypes, ct=>{
       params.customerTypes.push(ct);
      })

      params.customerClasses=[];
       _.forEach(state.filters.checkedCustomerClasses, c=>{
       	params.customerClasses.push(c);
       })


     params.orderBy = state.orderBy.orderName;
     params.direction = state.orderBy.direction;
     params.searchTerms = state.search;

      params.limit = state.per_page;
      params.page = page==null?state.page:page;

      if(params.page==0)params.page=1;
      // console.log(state);
      if(state.outDated || _.isEmpty(state.list)){
        //commit('changeLoadingState', true);
        // console.log("PARAMS : ", params);
        axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/contacts", {params : params})
          .then(response=>{
            // console.log(response);
            commit('update_contacts_list', response.data);

            // var randomContact = _.find(response.data.contacts, c=>{
            //   return c.type!=null;
            // });
            // commit('setFirstCorporateCustomer', firstCorporateCustomer);
            commit('changeLoadingState', false);

          })
      }

    },
    ['CONTACTS_CHANGE_CONTACT_PAGE'] : ({commit, dispatch}, page)=>{
      commit('invalidateList');
      dispatch('CONTACTS_LOAD_CONTACTS',page);
    },
    ['CONTACT_CHANGE_CONTACT_ASSOCIATED_FILTER']: ({commit, dispatch}, active)=>{
      commit('changeContactAssociatedFilter',active );
      commit('invalidateList');
      dispatch('CONTACTS_LOAD_CONTACTS');
    },
    ['CONTACT_CHANGE_CONTACT_NON_ASSOCIATED_FILTER']: ({commit, dispatch}, active)=>{
      commit('changeContactNonAssociatedFilter',active );
      commit('invalidateList');
      dispatch('CONTACTS_LOAD_CONTACTS');
    },['CONTACTS_SEARCH_CONTACT']: ({commit, dispatch}, search)=>{
        commit('updateContactSearch',search );
        commit('invalidateList');
        dispatch('CONTACTS_LOAD_CONTACTS');
    },['CONTACTS_INVALIDATE_LIST']: ({commit, dispatch}, search)=>{
        commit('invalidateList');
    },
    ['CONTACT_CHANGE_CUSTOMER_TYPE_FILTER'] : ({commit, dispatch}, checkedCustomerTypes)=>{
      commit('changeContactCustomerTypeFilter',checkedCustomerTypes );
      commit('invalidateList');
      dispatch('CONTACTS_LOAD_CONTACTS');
    },
    ['CONTACT_CHANGE_CUSTOMER_CLASS_FILTER'] : ({commit, dispatch}, checkedCustomerClasses)=>{
      commit('changeContactCustomerClassFilter',checkedCustomerClasses );
      commit('invalidateList');
      dispatch('CONTACTS_LOAD_CONTACTS');
    },
    ['CONTACT_CHANGE_CONTACT_TAGS_FILTER'] : ({commit, dispatch}, checkedContactTag)=>{
      commit('changeContactTag',checkedContactTag );
      commit('invalidateList');
      dispatch('CONTACTS_LOAD_CONTACTS');
    }
}

  export default {
    state,
    getters,
    actions,
    mutations,
  }
